import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const AssociadoShow = lazy(() => import("../externa/evento/AssociadoShow"));
const TerceiroShow = lazy(() => import("../externa/evento/TerceiroShow"));
const VistoriaShow = lazy(() => import("../externa/vistoria/VistoriaShow"));
const InfoAssociadoShow = lazy(() => import("../externa/associado/AssociadoShow"));
const CotacaoShow = lazy(() => import("../externa/cotacao/CotacaoShow"));
const ContratoShow = lazy(() => import("../externa/associado/ContratoShow"));
const PagamentoShow = lazy(() => import("../externa/pagamento/PagamentoShow"));

export default function ExternaPage() {
    return (
        <Switch>
            <Route path="/ext/evento/associado" component={AssociadoShow} />
            <Route path="/ext/evento/terceiro" component={TerceiroShow} />
            <Route path="/ext/vistoria/:id" component={VistoriaShow} />
            <Route path="/ext/cotacao/:id" component={CotacaoShow} />
            <Route path="/ext/pagamento/:id" component={PagamentoShow} />
            <Route path="/ext/associado/meus-contratos" component={ContratoShow} />
            <Route path="/ext/associado/:id/completar-dados" component={InfoAssociadoShow} />
        </Switch>
    );
}
